import { Column, Text } from '~/commonComponents';
import { Colors } from '~/themes/colors';

interface IHowItWorksCardProps {
  icon: string;
  title: string;
  description: string;
}

export const HowItWorksCard: React.FC<IHowItWorksCardProps> = ({ icon, title, description }) => {
  return (
    <Column alignItems="center" flex={1} padding="0 20px" gap={12}>
      <img src={icon} alt={title} style={{ width: 60, height: 60 }} />
      <Text bold fontSize={18} color={Colors.primary_500} textAlign="center">
        {title}
      </Text>
      <Text fontSize={16} color={Colors.neutral_600} textAlign="center">
        {description}
      </Text>
    </Column>
  );
};
